var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailsentIcn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#3A9ED1;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#777777;}\n\t.st2{fill:#3A9ED1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,0C20.1,0,0,20.1,0,45s20.1,45,45,45s45-20.2,45-45S69.8,0,45,0z M45,88C21.3,88,2,68.7,2,45S21.3,2,45,2 s43,19.3,43,43S68.7,88,45,88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.3,40.7v0.4v25.6l-13-13l-0.2-0.2l13.2-13.2V40.7z M23.9,67.9l1.1-1.1l18.7-18.7c0.9-0.9,2.4-0.9,3.3,0 l18.2,18.2l1.1,1.1l0.4,0.4H23.9z M22.3,42v-0.9v-0.4v-0.3l13.1,13.1l-0.2,0.1l-13,13V42z M23.5,36.8l6.8-6.8v15.6l-7.8-7.8 L23.5,36.8z M52.3,22l6,6v19.5l-4.6,4.6l-4.6-4.6l-0.7-0.7c-0.8-0.8-1.9-1.3-3.1-1.3c-1.2,0-2.2,0.5-3.1,1.3l-5.4,5.4l-4.5-4.5V22 H52.3z M43.7,16.6c0.9-0.9,2.4-0.9,3.3,0l3.3,3.3h-10L43.7,16.6z M68.1,37.7l-7.8,7.7V30L68.1,37.7z M70.2,37l-9.8-9.8L53.1,20 l-4-4l-0.7-0.7c-0.8-0.8-1.9-1.3-3.1-1.3c-1.2,0-2.2,0.5-3.1,1.3L37.5,20h-7.2v7.2l-1.5,1.5l-6,6l-2.5,2.5V38v32h50V38v-0.8 L70.2,37z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.3,
    y: 28,
    className: "st2",
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.3,
    y: 40,
    className: "st2",
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.3,
    y: 34,
    className: "st2",
    width: 10,
    height: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailsentIcn);
export default __webpack_public_path__ + "static/media/emailsent_icn.8633ce72e20cf10a71515541594fcd76.svg";
export { ForwardRef as ReactComponent };